import { Card, Footer, PageLayout, Typography } from '@bharatpe/bharat-ui';
import React, { useEffect } from 'react';
import { useSettlementAccount } from 'Slices/GetSettlementAccount';
import history from 'utils/History';
import './styles.scss';
import { logAnalyticsEvent } from 'utils/AnalyticsEvent';
import { useLanguageConfig } from 'Slices/LanguageConfigSlice';

const SimFailure = () => {
	const settlementAccount = useSettlementAccount();
	const { languageData } = useLanguageConfig();

	const bankDetails = settlementAccount.data.data;
	useEffect(() => {
		logAnalyticsEvent({
			trigger_point: 'Page View',
			Product: 'AutoPayUPI',
			Flow: 'SetupUPI',
			Screen: 'SimNotLinked',
			Module: 'Page',
			Action: 'Viewed',
		});
	}, []);
	const handleBack = () => {
		logAnalyticsEvent({
			trigger_point: `Clicks on Continue`,
			Product: 'AutoPayUPI',
			Flow: 'SetupUPI',
			Screen: 'SimNotLinked',
			Module: 'Continue',
			Element: 'CTA',
			Action: 'Tapped',
			ctaType: 'continue',
		});
		history.push({ pathname: '/upi/sim-binding' });
	};

	return (
		<PageLayout
			className="pb18 white-background"
			footerContent={<Footer primaryActionText={languageData.CONTINUE} primaryAction={handleBack} />}>
			<Card className="flex flex-column m4 p3 sim-card">
				<div className="content-center mb4">
					<Typography className="Bold600 danger">{languageData.ACCOUNT_IS_NOT_LINKED}</Typography>
				</div>
				<div className="flex flex-column content-center mb4">
					<Typography className="Regular100">{languageData.SELECTED_SIM_IS_NOT_LINKED_WITH_THE} </Typography>
					<Typography className="SemiBold200">
						{bankDetails?.name || ' '} XXXX XXXX {bankDetails?.account.slice(-4)}{' '}
					</Typography>
				</div>
				<div className="content-center mb4" onClick={handleBack}>
					<Typography className="Regular200 primary">{languageData.CHANGE_SIM_AND_APPLY_THE_LOAN_AGAIN}</Typography>
				</div>
			</Card>
		</PageLayout>
	);
};
export default SimFailure;
